module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article.81a4808d.webp";